import { BMText, useBMTheme } from "@traveloka/district-bloom";
import IcSystemChevronDown from "@traveloka/icon-kit-web/react/IcSystemChevronDown";
import { Animated } from "react-native";
import BMView from "../../../../components/View/BMView";
import { appendTestId } from "../../../../utils";
import useCollapsibleAnimation from "../../../hooks/hooks";
import MenuItem from "../MenuItem";
import { MenuListProps } from "../types";
import { MenuListHeaderWrapper } from "./MenuListHeader";

const ROW_HEIGHT = 36; // fixed row height

export default function MenuList({
  accordion,
  title,
  menus,
  testID,
}: MenuListProps) {
  const isAccordion = !!accordion && title !== undefined;
  const isDefaultOpen = accordion?.opened ?? false;

  const { BMComponents } = useBMTheme();

  const {
    isOpen,
    contentAnimatedStyle,
    contentWrapperAnimatedStyle,
    chevronAnimatedStyle,
    onToggleAnimate,
  } = useCollapsibleAnimation({
    isAccordion,
    isDefaultOpen,
    initContentHeight: menus.length * ROW_HEIGHT,
  });

  return (
    <BMView flex>
      {title && (
        <MenuListHeaderWrapper
          isAccordion={isAccordion}
          onClick={isAccordion ? onToggleAnimate : undefined}
        >
          <BMText
            variant="uiNormalLi"
            ink="BMStyleTextInkSecondary"
            testID={appendTestId(testID, "title")}
          >
            {title}
          </BMText>
          {isAccordion && (
            <Animated.View
              style={chevronAnimatedStyle}
              testID={appendTestId(testID, "chevron")}
            >
              <IcSystemChevronDown
                width={24}
                height={24}
                color={BMComponents.BMStyleIconInkPrimary}
                accentColor={BMComponents.BMStyleIconInkPrimary}
              />
            </Animated.View>
          )}
        </MenuListHeaderWrapper>
      )}
      <Animated.View style={contentWrapperAnimatedStyle}>
        <Animated.View
          style={contentAnimatedStyle}
          pointerEvents={isOpen ? "auto" : "none"}
        >
          {menus.map((item, index) => {
            if (item.type === "ITEM") {
              return <MenuItem key={`menu-item-${index}`} {...item} />;
            }
            return <BMView key={`menu-item-${index}`}>{item.component}</BMView>;
          })}
        </Animated.View>
      </Animated.View>
    </BMView>
  );
}
